import React, { useEffect, useState } from 'react';
import HeaderDashboard from '../header/headerDashboard';
import { Table, Button } from 'react-bootstrap';

const Histories = () => {
    const [histories, setHistories] = useState([]);
    const [openPayments, setOpenPayments] = useState([]);

    const fetchHistories = () => {
        fetch(`${process.env.REACT_APP_API_URL}/histories/`, {
            method: 'GET',
            credentials: 'include',
            headers: new Headers({
                'Content-Type': 'application/json',
            })
        })
            .then(async (res) => {
                if (res.status === 200) return res.json();
                throw await res.json();
            })
            .then((res) => {
                setHistories(res);
            }).catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        fetchHistories();
    }, []);

    const handlePaiement = () => {
        fetch(`${process.env.REACT_APP_API_URL}/histories/`, {
            method: 'POST',
            credentials: 'include',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify({
                status: 'Paiement',
                client: 'Paiement',
                pharmacy: 'Paiement'
            })
        })
            .then(async (res) => {
                if (res.status === 200) return res.json();
                throw await res.json();
            })
            .then(() => {
                fetchHistories();
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const paymentIndexes = histories
        .map((h, index) => ({ ...h, index }))
        .filter(h => h.status === 'Paiement')
        .map(h => h.index);

    const lastPaymentIndex = paymentIndexes.length > 0 ? paymentIndexes[paymentIndexes.length - 1] : -1;
    const unpaidBeds = lastPaymentIndex !== -1 ? histories.slice(lastPaymentIndex + 1) : histories;

    const togglePayment = (index) => {
        setOpenPayments(openPayments.includes(index)
            ? openPayments.filter(i => i !== index)
            : [...openPayments, index]);
    };

    const formatDate = (date) => new Date(date).toLocaleDateString('fr-FR');

    return (
        <div style={{ width: '100%', overflowX: 'hidden' }}>
            <HeaderDashboard />

            {/* Vue mobile */}
            <div className="d-block d-md-none" style={{ padding: '8px' }}>
                <h2 style={{ fontSize: 18, fontWeight: 'bold', marginBottom: 12 }}>Historique</h2>

                {/* Paiements avec leurs lits */}
                {paymentIndexes.map((paymentIndex, i) => {
                    const isOpen = openPayments.includes(paymentIndex);
                    const previousPaymentIndex = i > 0 ? paymentIndexes[i - 1] : -1;
                    const bedsBetweenPayments = histories.slice(previousPaymentIndex + 1, paymentIndex);

                    return (
                        <React.Fragment key={paymentIndex}>
                            {/* Carte paiement */}
                            <div
                                onClick={() => togglePayment(paymentIndex)}
                                style={{
                                    borderLeft: '4px solid #0d6efd',
                                    borderRadius: 8,
                                    padding: '12px 14px',
                                    marginBottom: 6,
                                    backgroundColor: '#e8f0fe',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    cursor: 'pointer',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                }}
                            >
                                <div>
                                    <span style={{ fontWeight: 'bold', color: '#0d6efd', fontSize: 14 }}>
                                        💳 Paiement
                                    </span>
                                    <div style={{ fontSize: 12, color: '#555', marginTop: 2 }}>
                                        {formatDate(histories[paymentIndex].createdAt)}
                                        {bedsBetweenPayments.length > 0 && ` · ${bedsBetweenPayments.length} lit(s)`}
                                    </div>
                                </div>
                                <span style={{ fontSize: 16 }}>{isOpen ? '▲' : '▼'}</span>
                            </div>

                            {/* Lits entre paiements (expanded) */}
                            {isOpen && bedsBetweenPayments.map((bed, j) => (
                                <div
                                    key={`bed-${j}`}
                                    style={{
                                        borderLeft: '4px solid #adb5bd',
                                        borderRadius: 8,
                                        padding: '10px 14px',
                                        marginBottom: 6,
                                        marginLeft: 12,
                                        backgroundColor: '#f8f9fa',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                                    }}
                                >
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span style={{ fontWeight: 'bold', fontSize: 14 }}>Lit #{bed.number}</span>
                                        <span style={{ display: 'flex', gap: 6 }}>
                                            <span style={{
                                                fontSize: 11,
                                                padding: '2px 8px',
                                                borderRadius: 12,
                                                backgroundColor: bed.status === 'end' ? '#fde8e8' : '#e8fdf0',
                                                color: bed.status === 'end' ? '#c0392b' : '#27ae60',
                                                border: `1px solid ${bed.status === 'end' ? '#c0392b' : '#27ae60'}`,
                                            }}>
                                                {bed.status}
                                            </span>
                                            {bed.status === 'start' && bed.mattress && (
                                                <span style={{
                                                    fontSize: 11,
                                                    padding: '2px 8px',
                                                    borderRadius: 12,
                                                    backgroundColor: '#eaf3fb',
                                                    color: '#2980b9',
                                                    border: '1px solid #2980b9',
                                                }}>
                                                    🛏️ matelas
                                                </span>
                                            )}
                                        </span>
                                    </div>
                                    <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                                        {bed.client}{bed.pharmacy ? ` · ${bed.pharmacy}` : ''} · {formatDate(bed.createdAt)}
                                    </div>
                                </div>
                            ))}
                        </React.Fragment>
                    );
                })}

                {/* Lits non payés */}
                {unpaidBeds.length > 0 && (
                    <>
                        <div style={{ fontSize: 13, fontWeight: 'bold', color: '#856404', margin: '12px 0 6px' }}>
                            Non payés ({unpaidBeds.length})
                        </div>
                        {unpaidBeds.map((bed, i) => (
                            <div
                                key={i}
                                style={{
                                    borderLeft: '4px solid #ffc107',
                                    borderRadius: 8,
                                    padding: '10px 14px',
                                    marginBottom: 6,
                                    backgroundColor: '#fffbea',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                                }}
                            >
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span style={{ fontWeight: 'bold', fontSize: 14 }}>Lit #{bed.number}</span>
                                    <span style={{ display: 'flex', gap: 6 }}>
                                        <span style={{
                                            fontSize: 11,
                                            padding: '2px 8px',
                                            borderRadius: 12,
                                            backgroundColor: bed.status === 'end' ? '#fde8e8' : '#e8fdf0',
                                            color: bed.status === 'end' ? '#c0392b' : '#27ae60',
                                            border: `1px solid ${bed.status === 'end' ? '#c0392b' : '#27ae60'}`,
                                        }}>
                                            {bed.status}
                                        </span>
                                        {bed.status === 'start' && bed.mattress && (
                                            <span style={{
                                                fontSize: 11,
                                                padding: '2px 8px',
                                                borderRadius: 12,
                                                backgroundColor: '#eaf3fb',
                                                color: '#2980b9',
                                                border: '1px solid #2980b9',
                                            }}>
                                                🛏️ matelas
                                            </span>
                                        )}
                                    </span>
                                </div>
                                <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                                    {bed.client}{bed.pharmacy ? ` · ${bed.pharmacy}` : ''} · {formatDate(bed.createdAt)}
                                </div>
                            </div>
                        ))}
                    </>
                )}

                <Button variant="success" className="w-100 mt-3" onClick={handlePaiement}>
                    💰 Paiement
                </Button>
            </div>

            {/* Vue desktop */}
            <div className="d-none d-md-block" style={{ padding: '16px' }}>
                <h1>Historique</h1>
                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Numéro</th>
                            <th>Status</th>
                            <th>Date</th>
                            <th>Client</th>
                            <th>Pharmacie</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paymentIndexes.map((paymentIndex, i) => {
                            const isOpen = openPayments.includes(paymentIndex);
                            const previousPaymentIndex = i > 0 ? paymentIndexes[i - 1] : -1;
                            const bedsBetweenPayments = histories.slice(previousPaymentIndex + 1, paymentIndex);

                            return (
                                <React.Fragment key={paymentIndex}>
                                    <tr
                                        className="table-info"
                                        onClick={() => togglePayment(paymentIndex)}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <td>{histories[paymentIndex].number}</td>
                                        <td>{histories[paymentIndex].status}</td>
                                        <td>{formatDate(histories[paymentIndex].createdAt)}</td>
                                        <td>{histories[paymentIndex].client}</td>
                                        <td>{histories[paymentIndex].pharmacy}</td>
                                        <td>{isOpen ? '▲' : '▼'}</td>
                                    </tr>
                                    {isOpen && bedsBetweenPayments.map((bed, j) => (
                                        <tr key={`bed-${j}`} className="table-light">
                                            <td>{bed.number}</td>
                                            <td>{bed.status}{bed.status === 'start' && bed.mattress ? ' + matelas' : ''}</td>
                                            <td>{formatDate(bed.createdAt)}</td>
                                            <td>{bed.client}</td>
                                            <td>{bed.pharmacy}</td>
                                            <td>-</td>
                                        </tr>
                                    ))}
                                </React.Fragment>
                            );
                        })}
                        {unpaidBeds.map((bed, i) => (
                            <tr key={i} className="table-warning">
                                <td>{bed.number}</td>
                                <td>{bed.status}{bed.status === 'start' && bed.mattress ? ' + matelas' : ''}</td>
                                <td>{formatDate(bed.createdAt)}</td>
                                <td>{bed.client}</td>
                                <td>{bed.pharmacy}</td>
                                <td>-</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <Button variant="success" onClick={handlePaiement}>Paiement</Button>
            </div>
        </div>
    );
};

export default Histories;
